/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

export const ERROR_FILE_TYPE = "Wrong file provided.";
export const ERROR_READ_FILE = "Error reading file contents.";
export const ERROR_IS_REQUIRED = "You have to provide a file.";

export const PLACEHOLDER_NAME = "Display Name";
export const PLACEHOLDER_ID = "Provide Organisation ID";
export const PLACEHOLDER_TEXT = "Upload service account key json file";

export const ValuesMap = {
  type: "type",
  project_id: "projectId",
  private_key_id: "privateKeyId",
  private_key: "privateKey",
  client_email: "clientEmail",
  client_id: "clientId",
  auth_uri: "authUri",
  token_uri: "tokenUri",
  auth_provider_x509_cert_url: "authProviderX509CertUrl",
  client_x509_cert_url: "clientX509CertUrl",
} as const;

export const GCP_ROLE = {
  tokenCreator: "Service Account Token Creator",
  usageAdmin: "Service Usage Admin",
  objectCreator: "Storage Object Creator",
  assetViewer: "Cloud Asset Viewer",
  organizationViewer: "Organization Viewer",
  viewer: "Viewer",
};
